// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_3 from '/data/luanniao-ui-release/src/.umi-production/plugin-initialState/@@initialState';
import model_1 from '/data/luanniao-ui-release/src/models/global';
import model_2 from '/data/luanniao-ui-release/src/models/site';

export const models = {
model_3: { namespace: '@@initialState', model: model_3 },
model_1: { namespace: 'global', model: model_1 },
model_2: { namespace: 'site', model: model_2 },
} as const
